const ANALYTICS_EVENTS =  {
	VIEWER_INIT: "VIEWER_INIT",
	MODEL_LOADED: "MODEL_LOADED",
	MODEL_INIT: "MODEL_INIT",
	MODEL_ERROR: "MODEL_ERROR",
	ZOOM_INTERACTION: "ZOOM_INTERACTION",
	AR_INTERACTION: "AR_INTERACTION",
	PRODUCT_CONFIG: "PRODUCT_CONFIG",
	HOTSPOTS: "HOTSPOTS",
	CONFIG_UPDATED: "CONFIG_UPDATED",
};

export default ANALYTICS_EVENTS;
